import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { ValuesType } from '@shared/utils/utils';

import { SiteSummaryGridContext } from '../types/site-summary-grid-context';

export interface AgVisitHeaderComponentParams {
  visit: ValuesType<SiteSummaryGridContext['aggregateColumns']>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipDirective],
  styles: [
    `
      :host {
        display: block;
        overflow: hidden;
      }
    `,
  ],
  template: `
    <div class="flex items-center justify-center space-x-2">
      @let visit = params.visit;

      <p
        class="truncate"
        [auxTooltip]="visitName.offsetWidth < visitName.scrollWidth ? visit.name : ''"
        #visitName
      >
        {{ visit.name }}
      </p>

      @if (visit.optional) {
        <div class="flex items-center space-x-1">
          <aux-icon name="Check" [size]="12" />
          <p class="text-sm">Optional</p>
        </div>
      }
    </div>
  `,
})
export class AgVisitHeaderComponent implements IHeaderAngularComp {
  params!: AgVisitHeaderComponentParams & IHeaderParams;

  agInit(params: AgVisitHeaderComponentParams & IHeaderParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
